import {Pattern, match} from 'ts-pattern';

import type {Locale} from '@dms/api/base';

export const resolveAssistantInterestLanguage = (
  customerPreferredLocale: Locale | null,
  tenantDefaultLocale: Locale | null,
  availableLocales: readonly Locale[]
) => {
  const isCustomerLocaleAvailable =
    customerPreferredLocale !== null && availableLocales.includes(customerPreferredLocale);
  const isTenantLocaleAvailable =
    tenantDefaultLocale !== null && availableLocales.includes(tenantDefaultLocale);

  return match({
    customerPreferredLocale,
    tenantDefaultLocale,
    isCustomerLocaleAvailable,
    isTenantLocaleAvailable,
  })
    .with(
      {customerPreferredLocale: Pattern.nonNullable, isCustomerLocaleAvailable: true},
      ({customerPreferredLocale: preferredLocale}) => ({
        preferredLocale,
        languageSource: 'customerPreferredLocale' as const,
      })
    )
    .with(
      {tenantDefaultLocale: Pattern.nonNullable, isTenantLocaleAvailable: true},
      ({tenantDefaultLocale: preferredLocale}) => ({
        preferredLocale,
        languageSource: 'tenantDefaultLocale' as const,
      })
    )
    .otherwise(() => ({preferredLocale: null, languageSource: 'unknown' as const}));
};
